import UserDetails from '../ReusableComponents/UserDetails';
import '../ReusableComponents/ModulePage.css';
import Request from '../../Request';
import MeetingRecordings from '../ReusableComponents/MeetingRecordings';
import SectionButtons from '../ReusableComponents/SectionButtons';





import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';

// users
import moment from 'moment';
import { API_URL, STORAGE_URL, URL } from '../../variables';
import { maskNumber } from '../../Auxiliar/Masks';

import ReactPaginate from 'react-paginate';
import { MdEvent, MdMailOutline, MdMeetingRoom, MdSecurity, MdCheck, MdContentCopy, MdCopyAll, MdOutlineRule, MdReply } from 'react-icons/md';
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import ImageLoaderInput from '../ReusableComponents/ImageLoaderInput';
import Attention from '../ReusableComponents/Attention';
import { RiArrowGoBackLine } from 'react-icons/ri';
import DefaultButton from '../ReusableComponents/DefaultButton';
import JoditEditor from 'jodit-react';
import TabPanel from "../ReusableComponents/TabPanel";
import TextReadMore from '../ReusableComponents/TextReadMore';
import { CircularProgress, Snackbar } from "@material-ui/core";
import Videos from './Videos';
import './label.css';
import user4 from '../../assets/images/default.png';
import Relatorio from './Relatorio';
import Redacoes from './Redacoes';
import ImagesCam from './ImagesCam';
import Messages from './Messages';
import LogsConexao from './LogsConexao';
import Screens from './Screens';
import VideoAIEvents from './VideoAIEvents';

class ShowCandidato extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            path: '/',
            loading_screen: true,
            roles: [],
            name: '',
            caminho: '',
            termos: '',
            loading_save: false,
            msgErro: '',
            loading_image: false,
            candidato: {},
            activeTab: 0,
            show_more: false,
            processo:{},
            sala:{},
            processo_resultado:{}
        };

    }


    get_candidato(id) {

        if (this.state.loading_screen == false) {
            this.setState({ loading_screen: true });
        }
        fetch(`${URL}api/faculdade/get_candidato/${id}/${this.props.match.params.processo_id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token'); localStorage.removeItem('user');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    this.setState({ redirect: true });

                    //   setTimeout(()=>{
                    //     this.get_processo();
                    //   });
                }
                else {
                    // this.props.mudarUser(resp.user);
                    this.setState({
                        loading_screen: false, candidato: resp.aluno, processo:resp.aluno.processo,
                        processo_resultado:resp.aluno.processo_resultado,
                        sala:resp.aluno.sala,
                    });
                    // if (resp.processo != null) {


                }




            } catch (err) {
                this.setState({ redirect: true });
                console.log(err);


            }

        })
            .catch((err) => {
                this.setState({ redirect: true });

                console.log(err);
                // this.props.mudarLoadingHome(false);
            });
    }






    componentDidMount() {
        let tab = new URLSearchParams(this.props.location.search).get('tab');
        if (tab !== undefined && tab !== null) this.setState({ activeTab: parseInt(tab) });
        else if (tab === null) this.setState({ activeTab: 0 });
        this.get_candidato(this.props.match.params.id);
    }







    componentDidUpdate(previousProps) {
        if (previousProps.location.search !== this.props.location.search) {
            const tab = Number(new URLSearchParams(this.props.location.search).get('tab') || 0);
            if (tab !== this.state.activeTab) this.setState({ activeTab: tab });
        }
    }

    recordingRequest = async (path, method = 'GET') => {
        const response = method === 'POST' ? await Request.Post(path, new FormData()) : await Request.Get(path);
        if (response?.message === 'Unauthenticated.') this.props.logout();
        return response;
    };

    render() {
        const onlineSections = !!this.props.user?.empresa?.online_proccess && !!this.state.processo.online;
        const interviewRecordings = !!this.state.processo.is_interview;
        const supervisorRecordings = interviewRecordings || (onlineSections && !!this.state.candidato.accessibility && !!this.state.candidato.type_supervisor && this.state.candidato.type_supervisor !== 'none');
        const sections = [{ value: 0, label: 'Relatório de Acesso', description: 'Consulte o histórico de acesso e atividades.', icon: 'relatorio', visible: true },
{ value: 1, label: 'Avaliações', description: 'Veja as avaliações e correções do candidato.', icon: 'provas', visible: true },
{ value: 2, label: 'Mensagens', description: 'Consulte as conversas com os fiscais.', icon: 'mensagens', visible: onlineSections },
{ value: 3, label: 'Vídeos', description: 'Assista aos registros da câmera.', icon: 'videos', visible: onlineSections },
{ value: 9, label: 'Gravações', description: interviewRecordings ? 'Assista à entrevista com todos os avaliadores.' : 'Assista às chamadas com os fiscais.', icon: 'videos', visible: supervisorRecordings },
{ value: 5, label: 'Imagens', description: 'Veja as imagens capturadas da câmera.', icon: 'imagens', visible: onlineSections },
{ value: 6, label: 'Logs de conexão', description: 'Consulte as conexões e desconexões.', icon: 'logs', visible: onlineSections },
{ value: 7, label: 'Vídeos da Tela', description: 'Assista aos registros da tela compartilhada.', icon: 'telas', visible: onlineSections },
{ value: 8, label: 'Eventos IA', description: 'Veja as ocorrências detectadas pela IA.', icon: 'eventos', visible: onlineSections },
];
        const selectedTab = sections.some(item => item.value === this.state.activeTab && item.visible !== false) ? this.state.activeTab : 0;
        const selectedSection = sections.find(item => item.value === selectedTab && item.visible !== false);
        if (this.state.loading_screen) return <SkeletonCoursePage />
        else return (
            <div className="module-page module-profile">
                <div className="card module-card module-identity">
                    <div className="card-body">
                        <div className="module-heading">
                            <img className="module-avatar" src={this.state.candidato.imagem != null ? STORAGE_URL + this.state.candidato.imagem : user4} alt={`Foto de ${this.state.candidato.name}`} />
                            <div className="module-heading-text">
                                <p className="module-identity-label">Candidato · {this.state.processo.name}</p>
                                <h1>{this.state.candidato.name}</h1>
                                <div className="module-meta"><MdMailOutline aria-hidden="true" /><span>{this.state.candidato.email}</span></div>
                            </div>
                            <div className="module-back hidethis"><DefaultButton bg="secondary" text="Voltar" icon={<RiArrowGoBackLine />} search="?tab=7" to={`/processos/show/${this.state.processo.id}`} /></div>
                        </div>
                        <UserDetails user={this.state.candidato} candidate processId={this.state.processo.id} identity={false} />
                        <div className="module-facts">
                            {onlineSections && <div className="module-fact"><span className="module-fact-icon"><MdEvent aria-hidden="true" /></span><div><span>Primeiro login</span><strong>{this.state.candidato.first_last?.first ? moment(this.state.candidato.first_last.first).format('DD/MM/YYYY HH:mm:ss') : 'Nunca acessou o sistema'}</strong></div></div>}
                            {onlineSections && <div className="module-fact"><span className="module-fact-icon is-orange"><MdEvent aria-hidden="true" /></span><div><span>Último login</span><strong>{this.state.candidato.first_last?.last ? moment(this.state.candidato.first_last.last).format('DD/MM/YYYY HH:mm:ss') : 'Nunca acessou o sistema'}</strong></div></div>}
                            {this.state.sala?.id && <div className="module-fact"><span className="module-fact-icon is-cyan"><MdMeetingRoom aria-hidden="true" /></span><div><span>Sala</span><strong>{this.state.sala.numero}</strong></div></div>}
                            <div className="module-fact"><span className="module-fact-icon is-green"><MdSecurity aria-hidden="true" /></span><div><span>Confiabilidade</span><strong>{this.state.candidato.trust_points ?? 'Não informada'}</strong></div></div>
                        </div>
                    </div>
                </div>
                <div className="card module-card module-selector hidethis">
                    <div className="card-body">
                        <h2 className="module-selector-title hidethis">Escolha um módulo para visualizar</h2>
                        <SectionButtons variant="modules" value={selectedTab} items={sections} onChange={value => {
                      this.setState({ activeTab: value });
                      const params = new URLSearchParams(this.props.location.search);
                      params.set('tab', value);
                      this.props.history.push({ search: `?${params.toString()}` });
                    }} />
                    </div>
                </div>
                <div className="card module-card module-content">
                    <div className="card-body">
                        {selectedSection && <div className="module-content-heading hidethis"><h2>{selectedSection.label}</h2><p>{selectedSection.description}</p></div>}
                        {supervisorRecordings && <TabPanel value={selectedTab} index={9}>
                            <MeetingRecordings candidateView interviewView={interviewRecordings} endpoint={`faculdade/candidate_recordings/${this.state.processo.id}/${this.state.candidato.id}`} request={this.recordingRequest} />
                        </TabPanel>}
                        <TabPanel value={selectedTab} index={0}>
                        <Relatorio trust={this.state.candidato.trust} trust_points={this.state.candidato.trust_points} processo_id={this.state.processo.id} candidato_id={this.state.candidato.id} candidato_name={this.state.candidato.name} />

                        </TabPanel>
                        
                        
                        <TabPanel value={selectedTab} index={1}>
                        <Redacoes processo_id={this.state.processo.id} candidato_id={this.state.candidato.id} candidato_name={this.state.candidato.name} />

</TabPanel>
{this.props.user?.empresa?.online_proccess==true && this.state.processo.online==true && 
    <TabPanel value={selectedTab} index={2}>
                        <Messages processo_id={this.state.processo.id} candidato_id={this.state.candidato.id} candidato_name={this.state.candidato.name} />

                        </TabPanel>}
                        {this.props.user?.empresa?.online_proccess==true && this.state.processo.online==true && <TabPanel value={selectedTab} index={3}>
                            {/* <AddToCourse/> */}
                            <Videos processo_id={this.state.processo.id} candidato_id={this.state.candidato.id} candidato_name={this.state.candidato.name} />

                        </TabPanel>}


                        {this.props.user?.empresa?.online_proccess==true && this.state.processo.online==true && <TabPanel value={selectedTab} index={5}>
                        <ImagesCam processo_id={this.state.processo.id} candidato_id={this.state.candidato.id} candidato_name={this.state.candidato.name} />

                        </TabPanel>}

                        {this.props.user?.empresa?.online_proccess==true && this.state.processo.online==true && <TabPanel value={selectedTab} index={6}>
                        <LogsConexao processo_id={this.state.processo.id} candidato_id={this.state.candidato.id} candidato_name={this.state.candidato.name} />

                        </TabPanel>}

                        {this.props.user?.empresa?.online_proccess==true && this.state.processo.online==true && <TabPanel value={selectedTab} index={7}>
                            {/* <AddToCourse/> */}
                            <Screens processo_id={this.state.processo.id} candidato_id={this.state.candidato.id} candidato_name={this.state.candidato.name} />

                        </TabPanel>
                        }

                        {this.props.user?.empresa?.online_proccess==true && this.state.processo.online==true && <TabPanel value={selectedTab} index={8}>
                            <VideoAIEvents
                                processo_id={this.state.processo.id}
                                candidato_id={this.state.candidato.id}
                                candidato_name={this.state.candidato.name}
                                initial_source_origin={new URLSearchParams(this.props.location.search).get('source_origin') || 'all'}
                                initial_event_type={new URLSearchParams(this.props.location.search).get('event_type') || 'all'}
                            />
                        </TabPanel>}

                    </div>
                </div>
            </div>
        );
    }


}
const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
        user: state.AppReducer.user,

    }
);

const SkeletonCoursePage = () => {
    return (
        <div className="card">
            <div className="card-body">
                <div className="skeleton-title" />
                {/* <div className="skeleton-small-text skeleton-shimmer"/>
                <div className="skeleton-small-text skeleton-shimmer"/> */}
                <br />
                <div className="w100 flex jcc align-center">
                    <div className="skeleton-base skeleton-shimmer" style={{ width: "12em", height: "12em" }} />
                </div>
                <br />
                <div className="w100 skeleton-base skeleton-shimmer margin-bottom" style={{ minHeight: "48px" }} />
                <div className="w100 skeleton-base skeleton-shimmer margin-bottom" style={{ minHeight: "5em" }} />
                <div className="skeleton-small-button skeleton-shimmer" />
            </div>
        </div>
    );
}

export default connect(mapsStateToProps, { logout })(ShowCandidato);
